import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner, Alert } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import CategorisRecentPost from "./CategorisRecentPost";
import commnets from "../../../assets/img/comments.png";
import apiCall from "../../Api/api";

function ArticalCardDetaile() {
  const { articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);

        const response = await apiCall({
          url: `posts/view?id=${articleId}`,
          method: "GET",
          headers: "",
        });


        if (response?.status === 200) {
          const postData = response?.data?.data || response.data;
          setArticle(postData);
       
        } else {
          throw new Error("Article not found.");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load article. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [articleId]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" style={{ color: "#09422d" }} />
      </div>
    );
  }

  if (error || !article) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error || "Article Not Found"}</Alert>
      </Container>
    );
  }

  return (
    <>
      <section className="banner_section-inner packagebnner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="headingBnner_inner">
                  <h1>{article.caption}</h1>
                  {/* <h1>Dummy Text</h1> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="articals_wrapper py-3 margin_bottomfooter">
        <Container fluid="lg">
          <Row className="mb-4 justify-content-center">
            <Col lg={8} xxl={9} xl={8} className="pe-lg-5">
              <div className="card py-3 border-0 rounded-3">
                <div className="card-body">
                  <div className="aritcla-details">
                    <h1 className="articald-title pb-3">{article.caption}</h1>
                    <div className="aritcal_bigimg pb-4">
                      <img
                        src={article.full_image_path}
                        alt={article.title}
                        className="w-100"
                      />
                    </div>
                    <p>{article.content}</p>
                  </div>

                  <div className="tags-wrapper my-5 d-flex justify-content-between flex-wrap align-items-center">
                    <div className="d-flex align-items-center">
                      <h3 className="me-4 mb-0 tags-title">Tags</h3>
                      <div className="tags d-flex align-items-center flex-wrap gap-sm-2 gap-1">
                        {article.tags?.map((tag, i) => (
                          <Link
                            key={i}
                            to={`/article/tag/${tag}`}
                            className="tags-button"
                          >
                            <i className="fa-solid fa-tag pe-1"></i>
                            {tag}
                          </Link>
                        ))}
                      </div>
                    </div>
                    <div className="author_wrapper">
                      <ul className="artical-info">
                        <li>
                          <i className="fa-solid fa-user"></i>
                          <Link to={`/article/author/${article.author}`}>
                            {article.post_user_detail.name}
                          </Link>
                        </li>
                        <li>
                          <img src={commnets} alt="comments" />
                          <Link to="#comment-wrapper-section">
                            {article.comments_count}
                          </Link>
                        </li>
                        <li>
                          <i className="fa-solid fa-calendar-days"></i>{" "}
                          {article.date}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    className="comment-wrapper padding-artical"
                    id="comment-wrapper-section"
                  >
                    <div className="comment_hightfixed">
                      {article.comments?.length > 0 ? (
                        article.comments.map((comment, index) => (
                          <div key={index} className="comments-persons eee">
                            <div className="postcomment d-flex gap-3">
                              <div className="avatar">
                                <Link to={`/profile/user/${comment.username}`}>
                                  <img
                                    src={comment.userImage}
                                    alt={comment.username}
                                  />
                                </Link>
                              </div>
                              <div className="text_com">
                                <div className="requestContact d-flex gap-2 align-items-center font-color">
                                  <Link
                                    to={`/profile/user/${comment.username}`}
                                  >
                                    <h6 className="nameavatr">
                                      {comment.username}
                                    </h6>
                                  </Link>
                                  <span className="comment-date">
                                    {comment.date}
                                  </span>
                                </div>
                                <p>{comment.text}</p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="commentCount mb-4">
                          <h6>No Comments Yet</h6>
                        </div>
                      )}
                    </div>
                    <p className="px-3 pt-2 text-center">
                      Please{" "}
                      <Link
                        to="/site/login"
                        className="sign_intext parkrevieBtn text-center"
                      >
                        Sign in
                      </Link>{" "}
                      to Comment
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <div className="col-lg-3 col-xl-3 col-xxl-3 mt-lg-0 mt-3 ps-lg-0">
              <CategorisRecentPost />
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ArticalCardDetaile;
